<div *ngIf="!isSignedIn" class="container-fluid bgimg d-flex justify-content-center align-items-center">
  <a href="#" style="align-self: flex-start;margin-top: 10px;">
    <img src="assets/img/Agilosoft-logo-noBg.png" style="height: 70px;margin-top: 10px;">
  </a>
  <div class="card bg-transparent border-0" style="left: -3%">
    <div class="card-body typewriter">
      <p data-text="Agilosoft Attendance & Leave System ." class="display-3">Agilosoft Attendance & Leave System.
      </p>
      <div class="row mt-3">
        <Button class="btn btn-outline-dark ml-auto mr-1" (click)="SignIn()">Sign In</Button>
        <a class="btn btn-outline-dark mr-auto ml-1" href="https://login.yahoo.com/account/create" target="_blank"> Sign
          Up</a>
      </div>

    </div>
  </div>
</div>

<div *ngIf="isSignedIn" class="wrapper sidebar_minimize">
  <div class="main-header">
    <!-- Logo Header -->
    <div class="logo-header" data-background-color="dark2">

      <a href="index.html" class="logo">
        <img src="assets/img/logo.svg" alt="navbar brand" class="navbar-brand">
      </a>
      <button class="navbar-toggler sidenav-toggler ml-auto" type="button" data-toggle="collapse" data-target="collapse"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon">
          <i class="icon-menu"></i>
        </span>
      </button>
      <button class="topbar-toggler more"><i class="icon-options-vertical"></i></button>
      <div class="nav-toggle">
        <button class="btn btn-toggle toggle-sidebar">
          <i class="icon-menu"></i>
        </button>
      </div>
    </div>
    <!-- End Logo Header -->

    <!-- <button (click) = "Test()"></button> -->

    <!-- Navbar Header -->
    <nav class="navbar navbar-header navbar-expand-lg" data-background-color="dark">

      <div class="container-fluid">
        <div class="collapse" id="search-nav">
          <form class="navbar-left navbar-form nav-search mr-md-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <!-- <button type="submit" class="btn btn-search pr-1">
                  <i class="fa fa-search search-icon"></i>
                </button> -->
                Hello
              </div>
              <input type="text" placeholder="Search ..." class="form-control">
            </div>
          </form>
        </div>
        <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
          <li class="nav-item toggle-nav-search hidden-caret">
            <a class="nav-link" data-toggle="collapse" href="#search-nav" role="button" aria-expanded="false"
              aria-controls="search-nav">
              <i class="fa fa-search"></i>
            </a>
          </li>
          <!-- <li class="nav-item dropdown hidden-caret">
                        <a class="nav-link dropdown-toggle" href="#" id="messageDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-envelope"></i>
                        </a>
                        <ul class="dropdown-menu messages-notif-box animated fadeIn" aria-labelledby="messageDropdown">
                            <li>
                                <div class="dropdown-title d-flex justify-content-between align-items-center">
                                    Messages
                                    <a href="#" class="small">Mark all as read</a>
                                </div>
                            </li>
                            <li>
                                <div class="message-notif-scroll scrollbar-outer">
                                    <div class="notif-center">
                                        <a href="#">
                                            <div class="notif-img">
                                                <img src="assets/img/jm_denis.jpg" alt="Img Profile">
                                            </div>
                                            <div class="notif-content">
                                                <span class="subject">Jimmy Denis</span>
                                                <span class="block">
                                                    How are you ?
                                                </span>
                                                <span class="time">5 minutes ago</span>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div class="notif-img">
                                                <img src="assets/img/chadengle.jpg" alt="Img Profile">
                                            </div>
                                            <div class="notif-content">
                                                <span class="subject">Chad</span>
                                                <span class="block">
                                                    Ok, Thanks !
                                                </span>
                                                <span class="time">12 minutes ago</span>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div class="notif-img">
                                                <img src="assets/img/mlane.jpg" alt="Img Profile">
                                            </div>
                                            <div class="notif-content">
                                                <span class="subject">Jhon Doe</span>
                                                <span class="block">
                                                    Ready for the meeting today...
                                                </span>
                                                <span class="time">12 minutes ago</span>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div class="notif-img">
                                                <img src="assets/img/talha.jpg" alt="Img Profile">
                                            </div>
                                            <div class="notif-content">
                                                <span class="subject">Talha</span>
                                                <span class="block">
                                                    Hi, Apa Kabar ?
                                                </span>
                                                <span class="time">17 minutes ago</span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a class="see-all" href="javascript:void(0);">See all messages<i
                                        class="fa fa-angle-right"></i> </a>
                            </li>
                        </ul>
                    </li> -->
          <li class="nav-item dropdown hidden-caret">
            <a class="nav-link dropdown-toggle" href="#" id="notifDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-bell"></i>
              <span class="notification">4</span>
            </a>
            <ul class="dropdown-menu notif-box animated fadeIn" aria-labelledby="notifDropdown">
              <li>
                <div class="dropdown-title">You have 4 new notification(s)</div>
              </li>
              <li>
                <div class="notif-scroll scrollbar-outer">
                  <div class="notif-center">
                    <a href="#">
                      <div class="notif-icon notif-primary"> <i class="fa fa-user-plus"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          New user registered
                        </span>
                        <span class="time">5 minutes ago</span>
                      </div>
                    </a>
                    <a href="#">
                      <div class="notif-icon notif-success"> <i class="fa fa-comment"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          Rahmad commented on Admin
                        </span>
                        <span class="time">12 minutes ago</span>
                      </div>
                    </a>
                    <a href="#">
                      <div class="notif-img">
                        <!-- <img src="assets/img/profile2.jpg" alt="Img Profile"> -->
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          Reza send messages to you
                        </span>
                        <span class="time">12 minutes ago</span>
                      </div>
                    </a>
                    <a href="#">
                      <div class="notif-icon notif-danger"> <i class="fa fa-heart"></i> </div>
                      <div class="notif-content">
                        <span class="block">
                          Farrah liked Admin
                        </span>
                        <span class="time">17 minutes ago</span>
                      </div>
                    </a>
                  </div>
                </div>
              </li>
              <li>
                <a class="see-all" href="javascript:void(0);">See all notifications<i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </li>
          <!-- <li class="nav-item dropdown hidden-caret">
                        <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
                            <i class="fas fa-layer-group"></i>
                        </a>
                        <div class="dropdown-menu quick-actions quick-actions-info animated fadeIn">
                            <div class="quick-actions-header">
                                <span class="title mb-1">Quick Actions</span>
                                <span class="subtitle op-8">Shortcuts</span>
                            </div>
                            <div class="quick-actions-scroll scrollbar-outer">
                                <div class="quick-actions-items">
                                    <div class="row m-0">
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-file-1"></i>
                                                <span class="text">Generated Report</span>
                                            </div>
                                        </a>
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-database"></i>
                                                <span class="text">Create New Database</span>
                                            </div>
                                        </a>
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-pen"></i>
                                                <span class="text">Create New Post</span>
                                            </div>
                                        </a>
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-interface-1"></i>
                                                <span class="text">Create New Task</span>
                                            </div>
                                        </a>
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-list"></i>
                                                <span class="text">Completed Tasks</span>
                                            </div>
                                        </a>
                                        <a class="col-6 col-md-4 p-0" href="#">
                                            <div class="quick-actions-item">
                                                <i class="flaticon-file"></i>
                                                <span class="text">Create New Invoice</span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li> -->
          <li class="nav-item dropdown hidden-caret">
            <a class="dropdown-toggle profile-pic" data-toggle="dropdown" href="#" aria-expanded="false">
              <div class="avatar-sm">
                <img src={{user?.photoURL}} alt="..." class="avatar-img rounded-circle">
              </div>
            </a>
            <ul class="dropdown-menu dropdown-user animated fadeIn">
              <div class="dropdown-user-scroll scrollbar-outer">
                <li>
                  <div class="user-box">
                    <div class="avatar-lg"><img src={{user?.photoURL}} alt="image profile" class="avatar-img rounded">
                    </div>
                    <div class="u-text">
                      <h4>{{employee?.FirstName}} {{employee?.LastName}} </h4>
                      <p class="text-muted text-nowrap">{{user?.email}}</p>
                      <a href="profile.html" class="btn btn-xs btn-secondary btn-sm">
                        View Profile
                      </a>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="dropdown-divider"></div>
                  <!-- <a class="dropdown-item" href="#">My Profile</a> -->
                  <a class="dropdown-item" href="#">My Balance</a>
                  <!-- <a class="dropdown-item" href="#">Inbox</a> -->
                  <!-- <div class="dropdown-divider"></div> -->
                  <a class="dropdown-item" href="#">Settings</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#" (click)="logout()">Logout</a>
                </li>
              </div>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
    <!-- End Navbar -->
  </div>

  <!-- Sidebar -->
  <div class="sidebar sidebar-style-1" data-background-color="dark2">
    <div class="sidebar-wrapper scrollbar scrollbar-inner">
      <div class="sidebar-content">
        <div class="user">
          <div class="avatar-sm float-left mr-2">
            <img src={{user?.photoURL}} alt="..." class="avatar-img rounded-circle">
          </div>
          <div class="info">
            <a data-toggle="collapse" href="#collapseExample" aria-expanded="true">
              <span>
                {{employee?.FirstName}} {{employee?.LastName}}
                <span *ngIf = "employee?.isAdmin" class="user-level">Administrator</span>
                <span *ngIf = "!employee?.isAdmin" class="user-level">Employee</span>
                <span class="caret"></span>
              </span>
            </a>
            <div class="clearfix"></div>

            <div class="collapse in" id="collapseExample">
              <ul class="nav">
                <li>
                  <a href="#profile">
                    <span class="link-collapse">My Profile</span>
                  </a>
                </li>
                <li>
                  <a href="#edit">
                    <span class="link-collapse">Edit Profile</span>
                  </a>
                </li>
                <li>
                  <a href="#settings">
                    <span class="link-collapse">Settings</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ul class="nav nav-primary">
          <!-- <li class="nav-section">
                        <span class="sidebar-mini-icon">
                            <i class="fa fa-ellipsis-h"></i>
                        </span>
                        <h4 class="text-section">Personal Section</h4>
                    </li> -->

          <li class="nav-item">
            <a data-toggle="collapse" class="collapsed" href="#dashboard">
              <i class="fas fa-home"></i>
              <p>Dashboard</p>
              <span class="caret"></span>
            </a>
            <div class="collapse" id="dashboard">
              <ul class="nav nav-collapse">
                <li>
                  <a routerLink="employee-view">
                    <span class="sub-item">Home</span>
                  </a>
                </li>
                <li>
                  <a routerLink="employee-view-report">
                    <span class="sub-item">View Reports</span>
                  </a>
                </li>
                <li>
                  <a routerLink="employee-view-request">
                    <span class="sub-item">View Requests</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-section">
            <span class="sidebar-mini-icon">
              <i class="fa fa-ellipsis-h"></i>
            </span>
            <h4 class="text-section">Admin Tools</h4>
          </li>
          <li class="nav-item" *ngIf="this.employee.isAdmin">
            <a data-toggle="collapse" routerLink="employee">
              <i class="fas fa-users"></i>
              <p>Manage Employees</p>
              <!-- <span class="caret"></span> -->
            </a>
            <!-- <div class="collapse" id="employeeManage">
              <ul class="nav nav-collapse">
                <li>
                  <a routerLink="employee">
                    <span class="sub-item">View Employees</span>
                  </a>
                </li>

                <li>
                  <a routerLink="attendance-view">
                    <span class="sub-item">View Attendances</span>
                  </a>
                </li>
              </ul>
            </div> -->
          </li>
          <li class="nav-item" *ngIf="this.employee.isAdmin">
            <a routerLink="attendance-summary">
              <i class="fas fa-table"></i>
              <p class="text-wrap">Attendance Summary</p>
              <!-- <span class="caret"></span> -->
            </a>
          </li>
          <li class="nav-item" *ngIf="this.employee?.isAdmin">
            <a routerLink="report">
              <i class="fas fa-file-invoice-dollar"></i>
              <p>Attendance Reports</p>
            </a>
          </li>
          <li class="nav-item" *ngIf="this.employee?.isAdmin">
            <a routerLink="change-request">
              <i class="fas fa-exchange-alt"></i>
              <p>Change Requests</p>
            </a>
          </li>

          <!-- <li class="nav-item">
                        <a href="#base">
                            <i class="fas fa-edit"></i>
                            <p class = "text-wrap">Outsourced Attendance</p>
                        </a>
                    </li> -->
        </ul>
      </div>
    </div>
  </div>
  <!-- End Sidebar -->

  <div class="main-panel">
    <div class="content" style="background-color: #e8e8e8;">
      <div class="panel-header" style="background-color: #1f283e;">
        <div class="page-inner py-5">
          <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">

          </div>
        </div>
      </div>
      <div class="page-inner mt--5">
        <div class="row mt--2">
          <div class="col-md-6">

          </div>

          <div class="col-md-6">

          </div>
        </div>
        <div class="row">
          <div class="col-md-8">

          </div>

          <div class="col-md-4">

          </div>
        </div>
        <div class="row row-card-no-pd">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="container-fluid my-4">

                      <h5 style="font-family:emoji; font-size: xxx-large;" class="d-flex justify-content-center">
                        Agilosoft Attendance and Leaves System
                      </h5>

                      <!-- <nav
                            class="navbar navbar-expand-sm bg-light navbar-dark justify-content-center">
                            <ul class="navbar-nav">

                                <li class="navbar-item">
                                    <button routerLink="employee-view" class="m-1 btn btn-dark"
                                        Button>Employee view
                                    </button>
                                </li>

                                <li class="navbar-item">
                                    <button routerLink="employee" class="m-1 btn btn-dark"
                                        Button>Employee details
                                    </button>
                                </li>

                                <li class="navbar-item">
                                    <button routerLink="attendance-summary" class="m-1 btn btn-dark"
                                        Button>Attendance Summary
                                    </button>
                                </li>

                                <li class="navbar-item">
                                    <button routerLink="report" class="m-1 btn btn-dark"
                                        Button>Attendance Reports
                                    </button>
                                </li>

                            </ul>
                        </nav> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row row-card-no-pd">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="container-fluid my-4">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

      </div>
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="footer">
      <div class="container-fluid">
        <nav class="pull-left">
          <ul class="nav">

            <li class="nav-item">
              <a class="nav-link" href="#">
                Help
              </a>
            </li>

          </ul>
        </nav>
        <div class="copyright ml-auto">
          2021, <a href="https://www.agilosoft.com">Agilosoft</a>
        </div>
      </div>
    </footer>
  </div>

</div>
